"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4381],{

/***/ 766042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BreadcrumbComp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);






var BreadcrumbComp = function(props) {
    var store_info = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }).store_info;
    var homeClick = function() {
        next_router__WEBPACK_IMPORTED_MODULE_2___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: "pointer category-breadcrumb ".concat((props === null || props === void 0 ? void 0 : props.classes) || "")
    }, props), {
        onClick: homeClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "mr2 relative",
                children: [
                    "Home",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "bottomborder"
                    })
                ]
            }),
            " ",
            "/"
        ]
    }));
};


/***/ }),

/***/ 684381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _CategoryHeaderBase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(374809);
/* harmony import */ var _CategoryHeaderProductCount__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(936852);
/* harmony import */ var _CategoryName__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(637630);
/* harmony import */ var _Breadcrumb__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(766042);
/* harmony import */ var _components_FilterAndSorting__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(474794);






var CategoryHeader2 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CategoryHeaderBase__WEBPACK_IMPORTED_MODULE_1__/* .CategoryHeaderBase */ .m, {
        classes: "category-header-2 flex items-center justify-center flex-column !tw-z-[2]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-center block-style",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Breadcrumb__WEBPACK_IMPORTED_MODULE_4__/* .BreadcrumbComp */ .Z, {
                        classes: "category-breadcrumb-2"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CategoryName__WEBPACK_IMPORTED_MODULE_3__/* .CategoryNameComp */ .l, {
                        classes: "category-name-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-between w-100 relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CategoryHeaderProductCount__WEBPACK_IMPORTED_MODULE_2__/* .CategoryProductCount */ .Z, {
                        classes: "tc center product-count-2"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FilterAndSorting__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CategoryHeader2);


/***/ }),

/***/ 374809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CategoryHeaderBase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(999534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);




var CategoryHeaderBase = function(_param) {
    var children = _param.children, classes = _param.classes, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "classes"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "category-header ".concat(classes || "")
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 936852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CategoryProductCount; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/LoadingScreen/index.tsx

function getRows(param) {
    var _rowNums = param.rowNums, rowNums = _rowNums === void 0 ? 6 : _rowNums, rowContainerStyles = param.rowContainerStyles, rowStyles = param.rowStyles;
    var rows = [];
    for(var i = 0; i < rowNums; i++){
        rows.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RowSkeleton, {
            rowContainerStyles: rowContainerStyles,
            rowStyles: rowStyles
        }));
    }
    return rows;
}
var LoadingScreen = function(param) {
    var _rowNums = param.rowNums, rowNums = _rowNums === void 0 ? 6 : _rowNums, _rowContainerStyles = param.rowContainerStyles, rowContainerStyles = _rowContainerStyles === void 0 ? {} : _rowContainerStyles, _rowStyles = param.rowStyles, rowStyles = _rowStyles === void 0 ? {} : _rowStyles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-flex tw-w-full tw-animate-pulse tw-flex-col tw-items-center tw-justify-center",
        children: getRows({
            rowNums: rowNums,
            rowContainerStyles: rowContainerStyles,
            rowStyles: rowStyles
        })
    });
};
var RowSkeleton = function(param) {
    var rowContainerStyles = param.rowContainerStyles, rowStyles = param.rowStyles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-border-b tw-border-solid tw-border-[#111C361F] tw-pr-[24px] tw-py-[22.5px] last:tw-border-none",
        style: rowContainerStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-h-[12px] tw-rounded-full tw-bg-[#E0E0E0]",
            style: rowStyles
        })
    });
};
/* harmony default export */ var Components_LoadingScreen = (LoadingScreen);

// EXTERNAL MODULE: ./src/containers/Collections/useGetTypeIdFromCanonicalDataStore.js
var useGetTypeIdFromCanonicalDataStore = __webpack_require__(130553);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CategoryHeaderWidget/CategoryHeaderProductCount/index.js








var CategoryProductCount = function(_param) {
    var _classes = _param.classes, classes = _classes === void 0 ? "" : _classes, props = (0,_object_without_properties/* default */.Z)(_param, [
        "classes"
    ]);
    var ref;
    var ref1 = (0,react.useState)(0), count = ref1[0], setCount = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            catalogData: state.catalogReducer,
            showOutOfStockItem: !((ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : (ref1 = ref.services) === null || ref1 === void 0 ? void 0 : ref1.hide_out_of_stock)
        };
    }), _catalogData = ref2.catalogData, categories = _catalogData.categories, catalog_items = _catalogData.catalog_items, productTags = _catalogData.productTags, showOutOfStockItem = ref2.showOutOfStockItem;
    var typeId = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.category_id).typeId;
    (0,react.useEffect)(function() {
        if ((0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories)).length) {
            var catId = typeId;
            if (catId) {
                var ref, ref1;
                var specificCatalogItem = catalog_items[catId];
                setCount(specificCatalogItem === null || specificCatalogItem === void 0 ? void 0 : (ref = specificCatalogItem.filter) === null || ref === void 0 ? void 0 : (ref1 = ref.call(specificCatalogItem, function(item) {
                    return item.is_active === constants/* ITEM_ACTIVE_STATUS.ACTIVE */.p4.ACTIVE && (showOutOfStockItem || !!(item === null || item === void 0 ? void 0 : item.available));
                })) === null || ref1 === void 0 ? void 0 : ref1.length);
            }
        }
    }, [
        categories,
        productTags,
        catalog_items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fade-in-label ttc product-count tw-h-[24px] ".concat(classes || ""),
            children: "".concat(count, " Product").concat(count === 1 ? "" : "s")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-h-[24px] tw-w-[127px] ".concat(classes || ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_LoadingScreen, {
                rowNums: 1,
                rowContainerStyles: {
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        })
    });
};


/***/ }),

/***/ 637630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CategoryNameComp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(999534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(629815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(326706);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var src_containers_Collections_useGetTypeIdFromCanonicalDataStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130553);






var CategoryNameComp = function(_param) {
    var _classes = _param.classes, classes = _classes === void 0 ? "" : _classes, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "classes"
    ]);
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), activeCategoryName = ref1[0], setActiveCategoryName = ref1[1];
    var ref2 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return {
            catalogData: state.catalogReducer
        };
    }), _catalogData = ref2.catalogData, categories = _catalogData.categories, productTags = _catalogData.productTags;
    var typeId = (0,src_containers_Collections_useGetTypeIdFromCanonicalDataStore__WEBPACK_IMPORTED_MODULE_3__/* .useGetTypeIdFromCanonicalDataStore */ .C)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.category_id).typeId;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (categories.length > 0 || productTags.length > 0) {
            var allCategories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(productTags || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(categories || []));
            var catId = typeId;
            if (catId) {
                var ref;
                var activeCatIndex = allCategories.findIndex(function(el) {
                    return el.id === Number(catId);
                });
                setActiveCategoryName(((ref = allCategories[activeCatIndex]) === null || ref === void 0 ? void 0 : ref.name) || "Available Items");
            }
        }
    }, [
        categories,
        productTags,
        typeId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "category-name ".concat(classes || ""),
        children: activeCategoryName
    });
};


/***/ }),

/***/ 474794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96031);
/**
 * This component will be responsible for handling filtering and sorting of a single category products
 */ 




var FilterAndSorting = function(props) {
    var setSelectedFilterInReducer = function setSelectedFilterInReducer(hideOutOfStock, sortOption) {
        var dataToSet = {
            is_hide_out_of_stock: hideOutOfStock,
            sort_option: sortOption
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setCatalogProductFilter */ .ls)(dataToSet));
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), selectedSortOption = ref1[0], setSelectedSortOption = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isHideOutOfStock = ref2[0], setIsHideOutOfStock = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openDropdown = ref3[0], setOpenDropdown = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var onFilterSelection = function(e, option) {
        e.stopPropagation();
        setOpenDropdown(false);
        setSelectedSortOption(option);
        setSelectedFilterInReducer(isHideOutOfStock, option);
    };
    var toggleHideOutOfStock = function(e) {
        e.stopPropagation();
        setIsHideOutOfStock(!isHideOutOfStock);
        setSelectedFilterInReducer(!isHideOutOfStock, selectedSortOption);
    };
    var dropdownClick = function() {
        setOpenDropdown(function(s) {
            return !s;
        });
    };
    var handleClickOutside = function(e) {
        if (ref.current && ref.current.contains(e.target)) {
            return;
        }
        setOpenDropdown(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "filter-sorting w-100 ".concat((props === null || props === void 0 ? void 0 : props.className) ? props.className : ""),
        ref: ref,
        onClick: dropdownClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "filter-sorting__box pointer flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mv0",
                        children: [
                            "Sort: ",
                            (selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.displayText) || "Default Option"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "ml1",
                        alt: "dropdown button",
                        src: "/assets/images/down-arrow-thin.svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "filter-sorting__dropdown ".concat(openDropdown ? "active" : ""),
                children: [
                    _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .SORTING_OPTIONS.map */ .Hy.map(function(option, index) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "filter-sorting__dropdown--item pointer ".concat(option.id === (selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.id) ? "active" : ""),
                            onClick: function(e) {
                                return onFilterSelection(e, option);
                            },
                            children: option.displayText
                        }, index);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                    _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FILTER_OPTIONS.map */ .dl.map(function(filter, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "filter-sorting__dropdown__checkbox-container flex justify-between items-center pointer ".concat(isHideOutOfStock ? "active" : ""),
                            onClick: function(e) {
                                return toggleHideOutOfStock(e);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mv0",
                                    children: filter.displayText
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/assets/images/checkbox-filled.svg",
                                    className: isHideOutOfStock ? "dib" : "dn"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "checkbox-empty ".concat(isHideOutOfStock ? "dn" : "dib")
                                })
                            ]
                        }, index);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FilterAndSorting);


/***/ }),

/***/ 130553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useGetTypeIdFromCanonicalDataStore; }
/* harmony export */ });
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268037);
/* harmony import */ var src_utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


var useGetTypeIdFromCanonicalDataStore = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref;
    var canonicalData = (0,src_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.catalogReducer.canonicalData;
    });
    return {
        typeId: +id || +(canonicalData === null || canonicalData === void 0 ? void 0 : (ref = canonicalData.item_group_details) === null || ref === void 0 ? void 0 : ref.id),
        isTypeCollection: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.COLLECTION */ .Rv.COLLECTION,
        isTypeCategory: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.CATEGORY */ .Rv.CATEGORY,
        isTypeTags: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.TAG */ .Rv.TAG
    };
};


/***/ })

}]);